import { render, staticRenderFns } from "./AccountsListView.vue?vue&type=template&id=08108e67"
import script from "./AccountsListView.vue?vue&type=script&lang=js"
export * from "./AccountsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports